import PersonNameRequirementOption from "../enum/PersonNameRequirementOption";

const getPersonNameRequiredOptionByValues = (
  firstNameRequired: boolean,
  lastNameRequired: boolean
): PersonNameRequirementOption => {
  if (firstNameRequired) {
    if (lastNameRequired) {
      return PersonNameRequirementOption.ALL_REQUIRED;
    }
    return PersonNameRequirementOption.FIRST_NAME_REQUIRED;
  }
  if (lastNameRequired) {
    return PersonNameRequirementOption.LAST_NAME_REQUIRED;
  }
  return PersonNameRequirementOption.NONE_REQUIRED;
};

export default getPersonNameRequiredOptionByValues;
